import { SolarCalculatorRequest } from './solar-calculator-request';
import { ConsumptionType, ProductionType } from '../../../services/analysis.service';
import { CalculatorResult } from './solar-calculator-result';

export class CalculatorResultWrapper {

  constructor(
    public productionType: ProductionType,
    public consumptionInputMethod: ConsumptionType,
    public result: CalculatorResult,
    public request: SolarCalculatorRequest,
  ) {
  }
}
